/**
 * deg度
 * rad弧度
 */

export var PI_2 = Math.PI * 2;
var RADIAN = Math.PI / 180;
export var DEG_TO_RAD = RADIAN;
export function degToRad(deg) {
  return DEG_TO_RAD * deg;
}
export var SHAPES = /*#__PURE__*/function (SHAPES) {
  SHAPES["RECT"] = "RECT";
  SHAPES["RRECT"] = "RRECT";
  SHAPES["CIRCLE"] = "CIRCLE";
  return SHAPES;
}({});